// @flow
import React from "react";
import ReactDOM from "react-dom";
import { Provider as ReduxProvider } from "react-redux";
import { ThemeProvider } from "styled-components";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import blue from "@material-ui/core/colors/blue";
import theme from "../../shared/theme";
import "./index.css";
import App from "./App";
import getStore from "../../shared/store/";
import { BrowserRouter as Router } from "react-router-dom";

import registerServiceWorker from "./registerServiceWorker";
const mui_theme = createMuiTheme({
	palette: {
		primary: blue,
	},
});

let store = getStore();

ReactDOM.render(
	<ReduxProvider store={store}>
		<MuiThemeProvider theme={mui_theme}>
			<ThemeProvider theme={theme}>
				<Router>
					<App />
				</Router>
			</ThemeProvider>
		</MuiThemeProvider>
	</ReduxProvider>,
	document.getElementById("root")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js